import { LegalPage } from "@/components/LegalPage";

const SECTIONS = [
    {
        heading: "Acceptance of These Terms",
        paragraphs: [
            "Welcome to SPCLIVE Studio (\"SPCLIVE\", \"we\", \"us\", \"our\"), operated at spclive.app. By creating an account, purchasing credits, or using any part of the Service — including the live studio, OBS output links and payment features — you agree to be bound by these Terms of Use. If you do not agree, do not use the Service.",
        ],
    },
    {
        heading: "The Service",
        paragraphs: [
            "SPCLIVE provides realtime AI-powered video transformation. Your camera feed is transformed live according to prompts and styles you choose, and can be output to broadcasting software such as OBS. The Service is provided on a prepaid credit basis: streaming consumes 2 credits per second while a session is live. When your balance reaches zero, streaming stops until you top up.",
        ],
    },
    {
        heading: "Accounts",
        paragraphs: [
            "You must provide accurate information when registering and keep your login credentials and private OBS link secret. You are responsible for all activity that occurs under your account, whether or not authorised by you. Notify us immediately via a support ticket if you suspect your account or OBS link has been compromised.",
            "You must be at least 18 years old, or the age of majority in your jurisdiction, to create an account.",
        ],
    },
    {
        heading: "Credits, Payments and Refunds",
        paragraphs: [
            "Credits are purchased through our payment partner (Flutterwave) at the prices displayed on the site. Credits have no cash value, are non-transferable, and cannot be exchanged or withdrawn as money. Credits that have already been consumed by streaming are strictly non-refundable. Refunds of unused credits are handled at our sole discretion and only where required by applicable law.",
        ],
    },
    {
        heading: "Acceptable Use — Prohibited Conduct",
        paragraphs: [
            "You agree NOT to use SPCLIVE to create, stream, broadcast or distribute content that:",
        ],
        bullets: [
            "Impersonates any real person with intent to deceive, defraud, blackmail or harm — including using AI transformation to pose as another identifiable individual without their consent;",
            "Is unlawful, fraudulent, defamatory, harassing, threatening, hateful or discriminatory;",
            "Sexualises, exploits or endangers minors in any way (zero tolerance — reported to authorities);",
            "Infringes any copyright, trademark, publicity or privacy right of any third party;",
            "Is used for scams, phishing, romance fraud, financial fraud or any deceptive commercial practice;",
            "Circumvents, probes or abuses the Service — including sharing OBS links publicly, reselling access, reverse engineering, scraping, or attempting to bypass credit metering.",
        ],
    },
    {
        heading: "Your Responsibility for Your Content",
        paragraphs: [
            "You are solely and entirely responsible for everything you create, stream or broadcast through SPCLIVE and for how you use the transformed output. SPCLIVE is a technology tool only: we do not monitor, endorse, or take responsibility for user content or for any unauthorised, illegal or improper use of the Service by any user. To the fullest extent permitted by law, you release SPCLIVE, its owner and operators from any liability arising out of your content or your use — including any misuse — of the Service.",
        ],
    },
    {
        heading: "Enforcement, Suspension and Termination",
        paragraphs: [
            "We reserve the sole and absolute right to suspend, block, deactivate or permanently delete any account, at any time, with or without prior notice, if we believe — at our sole discretion — that the account has been used in violation of these Terms, for unauthorised purposes, or in a way that harms the Service, other users or third parties.",
            "Accounts terminated for violations forfeit any remaining credit balance without refund. We may also cooperate with law enforcement and disclose relevant account information where legally required.",
        ],
    },
    {
        heading: "Intellectual Property",
        paragraphs: [
            "The SPCLIVE name, brand, interface and software are our property. Subject to these Terms, you retain rights you hold in your own camera footage; the transformed output you generate may be used by you for lawful purposes. You are responsible for ensuring your use of any transformed output complies with applicable law and third-party rights.",
        ],
    },
    {
        heading: "Third-Party Services",
        paragraphs: [
            "The Service depends on third-party providers, including AI model infrastructure, payment processing (Flutterwave) and email delivery. We are not responsible for outages, errors or acts of these third parties. Broadcasting software such as OBS is independent software governed by its own licences.",
        ],
    },
    {
        heading: "Disclaimer of Warranties",
        paragraphs: [
            "THE SERVICE IS PROVIDED \"AS IS\" AND \"AS AVAILABLE\" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING FITNESS FOR A PARTICULAR PURPOSE, UNINTERRUPTED AVAILABILITY, OR ERROR-FREE OPERATION. Realtime AI transformation quality depends on your camera, network and third-party infrastructure.",
        ],
    },
    {
        heading: "Limitation of Liability",
        paragraphs: [
            "To the maximum extent permitted by law, SPCLIVE and its owner shall not be liable for any indirect, incidental, special, consequential or punitive damages, loss of profits, data or goodwill arising from your use of — or inability to use — the Service. Our total aggregate liability for any claim shall not exceed the amount you paid to SPCLIVE in the three (3) months preceding the claim.",
        ],
    },
    {
        heading: "Indemnification",
        paragraphs: [
            "You agree to indemnify and hold harmless SPCLIVE, its owner and operators from any claims, damages, liabilities and expenses (including legal fees) arising from your content, your use of the Service, or your violation of these Terms or any law or third-party right.",
        ],
    },
    {
        heading: "Changes to These Terms",
        paragraphs: [
            "We may update these Terms from time to time. The \"Last updated\" date above reflects the latest revision. Continued use of the Service after changes take effect constitutes acceptance of the revised Terms.",
        ],
    },
    {
        heading: "Governing Law",
        paragraphs: [
            "These Terms are governed by the laws of the Federal Republic of Nigeria, without regard to conflict-of-law principles. Any disputes shall be subject to the exclusive jurisdiction of the courts of Nigeria.",
        ],
    },
];

export default function Terms() {
    return <LegalPage pageTestId="terms-page" title="Terms of Use" updated="June 2026" sections={SECTIONS} />;
}
